import { createFileRoute } from '@tanstack/react-router'
import { ToolPage } from '@/components/tool-page/tool-page'
import { toolHead } from '@/components/tool-page/tool-head'
import { DnsTool } from '@/components/tool-page/dns-tool'
import { TOOLS } from '@/lib/tool-content'

const content = TOOLS['mx-lookup']

export const Route = createFileRoute('/_site/tools/mx-lookup')({
  component: MxLookupPage,
  validateSearch: (search: Record<string, unknown>): { q?: string } => ({
    q: typeof search.q === 'string' && search.q ? search.q : undefined,
  }),
  head: () => toolHead(content),
})

function MxLookupPage() {
  const { q } = Route.useSearch()
  return (
    <ToolPage content={content}>
      <DnsTool content={content} fixedType="MX" initialName={q ?? ''} autoRun={!!q} />
    </ToolPage>
  )
}
